import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import useConfettiExplosion from 'hooks/useConfettiExplosion';
import Transition from '@/components/NewCart/Transition';
import styles from '@/components/NewCart/Reactions.module.css';
import { Reaction } from '@/components/NewCart/Reaction';

interface Props {
  reaction: Reaction;
  className: string;
  showConfetti: boolean;
  index: number;
  screenWidth: number;
}

const fadeDuration = 300;
const fade = {
  duration: fadeDuration,
  defaultStyle: {
    transition: `opacity ${fadeDuration}ms ease-in-out`,
    opacity: 0,
  },
  transitionStyles: {
    entering: { opacity: 1 },
    entered: { opacity: 1 },
    exiting: { opacity: 1, display: 'block' },
    exited: { opacity: 0, display: 'none' },
  },
};

const ReactionComponent = ({ reaction, className, showConfetti, index, screenWidth }: Props): JSX.Element => {
  const { emoji, label } = reaction;
  const [showLabel, setShowLabel] = useState(true);

  useEffect(() => {
    setTimeout(() => setShowLabel(false));
  }, []);

  const confetti = useConfettiExplosion(true, {
    force: 0.4,
    duration: 2200,
    particleCount: 30,
    width: 400,
  });

  const [showMockReaction, setShowMockReaction] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowMockReaction(true), 300);
  }, []);

  const reactionWidth = screenWidth < 720 ? '90px' : '120px';

  const transitionDuration = 250;
  const transition = {
    duration: transitionDuration,
    defaultStyle: {
      transition: `left ${transitionDuration}ms ease-in-out`,
      top: '50%',
      left: (() => {
        if (index === 0) return `calc(50% - ${reactionWidth})`;
        if (index === 2) return `calc(50% + ${reactionWidth})`;
        return '50%';
      })(),
      transform: 'translate(-50%,-50%)',
    },
    transitionStyles: {
      entering: {
        left: 'calc(100% - 5px)',
      },
      entered: {
        left: 'calc(100% - 5px)',
      },
    },
  };

  return (
    <Transition show={showMockReaction} {...transition}>
      <div className={classNames(styles.child, className)}>
        <div className={styles.emoji}>
          {emoji}
          {showConfetti && confetti}
        </div>
        <Transition show={showLabel} {...fade}>
          <span className={styles.label}>{label}</span>
        </Transition>
      </div>
    </Transition>
  );
};

export default ReactionComponent;
